import Vue from "vue";
import Profiles from './pages/front/straight/childs/Profiles.vue'


Vue.component('Profiles',Profiles)

